// extracted by mini-css-extract-plugin
module.exports = {"surroundingsIntro":"surroundings_surroundingsIntro__T9oMi","surroundingsTitle":"surroundings_surroundingsTitle__Jbf0x"};